import "./Footer.css";

function Footer() {
  return (
    <footer>
      <div style={{ textAlign: "center" }}>
        <a href="https://hits.seeyoufarm.com">
          <img src="https://hits.seeyoufarm.com/api/count/incr/badge.svg?url=https%3A%2F%2Fmaplehistorymo.shop&count_bg=%23000000&title_bg=%23000000&icon=openstreetmap.svg&icon_color=%23E7E7E7&title=Visitors&edge_flat=false" />
        </a>
      </div>
      <p>
        <span>Copyright 2024. 모(masindawater). All Rights Reserved.</span>
        <span className="footer-span">Helper : 울라리</span>
      </p>
    </footer>
  );
}

export default Footer;
